import { render, staticRenderFns } from "./dg-form-dialog.vue?vue&type=template&id=4352f812&scoped=true"
import script from "./dg-form-dialog.vue?vue&type=script&lang=js"
export * from "./dg-form-dialog.vue?vue&type=script&lang=js"
import style1 from "./dg-form-dialog.vue?vue&type=style&index=1&id=4352f812&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4352f812",
  null
  
)

export default component.exports